/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type PdpSharedDetailShipping_shipment$ref = any;
type PdpSharedDetailShipping_shipmentQuote$ref = any;
type PdpSharedDetailShipping_viewer$ref = any;
export type PdpSharedDetailShippingRefetchQueryVariables = {
    userId: string;
    fetchUser: boolean;
    itemId: string;
};
export type PdpSharedDetailShippingRefetchQueryResponse = {
    readonly viewer: {
        readonly relevantShipping: {
            readonly shipmentQuote: {
                readonly " $fragmentRefs": PdpSharedDetailShipping_shipmentQuote$ref;
            } | null;
            readonly shipment: {
                readonly " $fragmentRefs": PdpSharedDetailShipping_shipment$ref;
            } | null;
        } | null;
        readonly " $fragmentRefs": PdpSharedDetailShipping_viewer$ref;
    } | null;
};
export type PdpSharedDetailShippingRefetchQuery = {
    readonly response: PdpSharedDetailShippingRefetchQueryResponse;
    readonly variables: PdpSharedDetailShippingRefetchQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchUser",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "buyerId",
    "variableName": "userId"
  },
  {
    "kind": "Variable",
    "name": "itemId",
    "variableName": "itemId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "convertedAmountList",
  "storageKey": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v2/*: any*/)
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PdpSharedDetailShippingRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "relevantShipping",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "RelevantShippingInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipmentQuote",
                "storageKey": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "PdpSharedDetailShipping_shipmentQuote",
                    "args": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipment",
                "storageKey": null,
                "args": null,
                "concreteType": "Shipment",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "PdpSharedDetailShipping_shipment",
                    "args": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "PdpSharedDetailShipping_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PdpSharedDetailShippingRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "relevantShipping",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "RelevantShippingInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "quoteRequestStatus",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipmentQuote",
                "storageKey": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "subTotalAmount",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FinancialAmount",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isCustom",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isNew",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "status",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "handlingTimeDisplay",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "totalAmount",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FinancialAmount",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/),
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "buyerSubTotalAmount",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FinancialAmount",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "buyerServiceMethodDisplay",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "serviceMethod",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ShipmentServiceMethod",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "serviceMethodType",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "region",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Region",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "apiType",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "code",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "regionName",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "regionType",
                            "args": null,
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ]
                      },
                      (v5/*: any*/)
                    ]
                  },
                  (v5/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipment",
                "storageKey": null,
                "args": null,
                "concreteType": "Shipment",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shippingAddress",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Address",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "displayCityStateCountry",
                        "args": null,
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ]
                  },
                  (v5/*: any*/)
                ]
              }
            ]
          },
          (v5/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchUser",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "buyerItemConversation",
                "storageKey": null,
                "args": (v1/*: any*/),
                "concreteType": "Conversation",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "serviceId",
                    "args": null,
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PdpSharedDetailShippingRefetchQuery",
    "id": "app-buyer-finding/237.0.0-2019-10-18T13:55:49.909Z/PdpSharedDetailShippingRefetchQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '883be48e7dc4f5e0b3a4236094b57651';
export default node;
